import { render, staticRenderFns } from "./widgetNewReplaceBlack.vue?vue&type=template&id=1d8fd210&scoped=true&"
import script from "./widgetNewReplaceBlack.vue?vue&type=script&lang=js&"
export * from "./widgetNewReplaceBlack.vue?vue&type=script&lang=js&"
import style0 from "./widgetNewReplaceBlack.vue?vue&type=style&index=0&id=1d8fd210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8fd210",
  null
  
)

export default component.exports